export enum TimelineEntryType {
  APPOINTMENT = 'APPOINTMENT',
  ATTACHMENT = 'ATTACHMENT',
  ATTACHMENT_GROUP = 'ATTACHMENT_GROUP',
  CONVERSATION = 'CONVERSATION',
  DIAGNOSIS = 'DIAGNOSIS,PROBLEM_DIAGNOSIS',
  ESTIMATE = 'ESTIMATE',
  IMAGING = 'IMAGING',
  IMPORTED_HISTORY = 'IMPORTED_HISTORY',
  LAB_TEST = 'LAB_TEST',
  NOTE = 'NOTE',
  OTC_SALE = 'OTC_SALE',
  PRESCRIPTION = 'PRESCRIPTION',
  VET_DIET = 'VET_DIET',
  QUESTION = 'QUESTION',
  REMINDER = 'REMINDER',
  SURGERY = 'SURGERY',
  TASK = 'TASK',
  VACCINATION = 'VACCINATION',
  VITAL = 'VITAL',
}

export const TimelineEntryTypesList = Object.values(TimelineEntryType).filter(
  (type) => type !== TimelineEntryType.ATTACHMENT,
)

/** Timeline item map keys for prescription subtypes; keep in sync with timelineItems.tsx */
export const TIMELINE_KEY_PRESCRIPTION_PRESCRIPTION =
  'prescription.prescription'
export const TIMELINE_KEY_PRESCRIPTION_VET_DIET = 'prescription.vet_diet'

/** API subType values for timeline prescription filter; backend expects these literals. */
export const TIMELINE_SUBTYPE_VET_DIET = 'VET_DIET'
export const TIMELINE_SUBTYPE_DRUG = 'DRUG'
